// extracted by mini-css-extract-plugin
export var gif = "_jh-0";